<div class="layout-main">
  <div class="container-fluid">
    <nav *ngIf="loggedInUser && loggedInUser.company" class="navbar navbar-expand navbar-light bg-light mb-3 nav-style"
         id="breadcrumb-sf-1">
      <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
        <ol class="breadcrumb ol-sf-1 ol-nav">
          <li class="breadcrumb-item">
            <a *ngIf="loggedInUser.permissions.isMckayUser" routerLink="/mckay/{{loggedInUser.company.uniqid}}">Home</a>
            <a *ngIf="!loggedInUser.permissions.isMckayUser"
               routerLink="/client/{{loggedInUser.company.uniqid}}">Home</a>
          </li>
          <li aria-current="page" class="breadcrumb-item">
            List of Quincy E-trees
          </li>
        </ol>
      </nav>
    </nav>
    <div *ngIf="!loading">
      <div class="pb-2 mb-3 border-bottom">
        <h3><b>List of Quincy etrees </b></h3>
      </div>
      <p-table #dataTableQuincyEtrees [columns]="cols"
               [paginator]="true" [rowsPerPageOptions]="[10, 15, 20, 25, 30, 50, 100, 200, 500, 1000]" [rows]="10"
               [value]="filteredQuincyEtrees">
        <ng-template pTemplate="caption">
          <button (click)="onClickedResetFilter()" class="buttonResetItem pull-right" icon="fa fa-eraser" pButton
                  style="margin-top: 25px;" type="button"></button>
          <div class="p-grid p-fluid">
            <div class=" col-12 col-md-4 col-lg-2">
              <p-floatLabel>
                <input [(ngModel)]="userChoicesActiveFiltersQuincyEtrees.name" (input)="filterAndReset()" id="name"
                       pInputText type="text"/>
                <label for="name">
                  Name:
                </label>
              </p-floatLabel>
            </div>
            <div class="col-12 col-md-4 col-lg-2">
              <p-floatLabel>
                <input [(ngModel)]="userChoicesActiveFiltersQuincyEtrees.crossConnect" (input)="filterAndReset()" id="injection-xco"
                       pInputText type="text"/>
                <label for="injection-xco">
                  Injection cross connect:
                </label>
              </p-floatLabel>
            </div>
            <div class="col-12 col-md-4 col-lg-2">
              <p-floatLabel>
                <input [(ngModel)]="userChoicesActiveFiltersQuincyEtrees.vlan" (input)="filterAndReset()"
                       pInputText type="text"/>
                <label>
                  Vlan:
                </label>
              </p-floatLabel>
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <p-floatLabel>
                <p-dropdown [(ngModel)]="userChoicesActiveFiltersQuincyEtrees.injectionPop"
                            (onChange)="filterAndReset()"
                            [filter]="true"
                            [options]="formSelectValuesInjectionPops"
                            [showClear]="true"
                            inputId="injection-pop"></p-dropdown>
                <label>
                  Injection Pop:
                </label>
              </p-floatLabel>
            </div>
            <div class="col-12 col-md-4 col-lg-3">
              <p-floatLabel>
                <p-multiSelect [(ngModel)]="userChoicesActiveFiltersQuincyEtrees.receptionPops" (onChange)="filterAndReset()"
                               [filter]="true" [options]="formSelectValuesReceptionPops" inputId="reception-pop"></p-multiSelect>
                <label>
                  Reception Pop(s):
                </label>
              </p-floatLabel>
            </div>
          </div>
        </ng-template>
        <ng-template let-columns pTemplate="header">
          <tr>
            <th *ngFor="let col of cols" [pSortableColumn]="col.field"
                class="th-{{col.field}}">
              {{ col.header }}
              <p-sortIcon field="{{col.field}}"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template let-columns="columns" let-quincyEtree pTemplate="body">
          <tr>
            <td>
              <a [href]="'#/quincy-etree/'+quincyEtree.id">{{ quincyEtree.name }}</a>
            </td>
            <td><span [pTooltip]="technicalPopService.getCageTooltip(quincyEtree.marsInjectionPoint['site_technical_name'])">{{ quincyEtree.marsInjectionPoint['site_technical_name'] }}</span></td>
            <td>{{ quincyEtree.vlan }}</td>
            <td>{{ quincyEtree.marsInjectionCrossConnect }}</td>
            <td><span [pTooltip]="technicalPopService.getCageTooltip(getQuincyEtreesReceptionPoints(quincyEtree, 'site_technical_name'))">{{ getQuincyEtreesReceptionPoints(quincyEtree, 'site_technical_name') }}</span></td>
            <td>
              <a [href]="'#/quincy-etree/'+quincyEtree.id">Manage etree</a>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="text-right">
            Total Items: {{ filteredQuincyEtrees.length }} / {{ quincyEtrees?.length }}
          </div>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            No Quincy found
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
